import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject, Input } from 'angular-ts-decorators';
import { ProductContextService } from 'src/Foundation/Design/app';
import { getWtuAdditionalInfo } from '../utils/get-wtu-additional-info';
import template from './support-wtu.component.html';
var SupportWtuComponent = (function () {
    function SupportWtuComponent(productContextService) {
        this.productContextService = productContextService;
        this.additionalDataToSend = {};
    }
    Object.defineProperty(SupportWtuComponent.prototype, "contextProduct", {
        get: function () {
            return this.productContextService.getContext();
        },
        enumerable: false,
        configurable: true
    });
    SupportWtuComponent.prototype.ngOnInit = function () {
        this.setAdditionalDataToSend();
        this.productContextService
            .subscribe()
            .then(null, null, this.setAdditionalDataToSend.bind(this));
    };
    SupportWtuComponent.prototype.setAdditionalDataToSend = function () {
        if (!this.contextProduct) {
            this.additionalDataToSend = {};
            return;
        }
        this.additionalDataToSend = getWtuAdditionalInfo(this.contextProduct);
    };
    SupportWtuComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SupportWtuComponent.prototype, "contactSupportUrl", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SupportWtuComponent.prototype, "itemLink", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SupportWtuComponent.prototype, "resetOnChanges", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SupportWtuComponent.prototype, "sitecoreId", void 0);
    SupportWtuComponent = __decorate([
        Component({
            selector: 'supportWasThisUseful',
            template: template,
        }),
        __param(0, Inject('productContextService')),
        __metadata("design:paramtypes", [ProductContextService])
    ], SupportWtuComponent);
    return SupportWtuComponent;
}());
export { SupportWtuComponent };
